import { AiFillEye, AiFillDelete } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { isEmpty, startCase } from "lodash";
import { BsArrowUpShort } from "react-icons/bs";
import TableHeaderCell from "components/reusable/TableHeaderCell";

const FinalEmployeeTable = ({
  employeeList,
  page,
  sort,
  setSort,
  handleView,
  handleDelete,
}) => {
  const { t } = useTranslation();

  const handleSort = (sortByValue, sortTypeValue) => {
    const newSortType = sort.sortType === "asc" ? "desc" : "asc";
    setSort({
      sortBy: sortByValue,
      sortType: sortByValue === sort.sortBy ? newSortType : sortTypeValue,
    });
  };

  return (
    <div>
      <div className="p-3">
        <div className="overflow-x-auto rounded-lg border relative ">
          <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <TableHeaderCell text={t("SR_NO")} />
                {/* <TableHeaderCell text={t("EMPLOYEE_ID")} /> */}
                <TableHeaderCell text={t("EMPLOYEE_NAME")} />
                <TableHeaderCell text={t("DEPARTMENT")} />
                <TableHeaderCell text={t("JOB_TITLE")} />
                <TableHeaderCell text={t("YEAR_OF_EXPERIENCE")} />

                <th
                  scope="col"
                  onClick={() => handleSort("Employee.email", "asc")}
                  className="py-3 cursor-pointer px-6 "
                >
                  <div className="flex justify-start">
                    <span>{t("EMAIL_ID")}</span>
                    <span>
                      {sort.sortType === "asc" &&
                        sort.sortBy === "Employee.email" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortType === "desc" &&
                        sort.sortBy === "Employee.email" && (
                          <BsArrowUpShort className="h-4 rotate-180 w-4 " />
                        )}
                    </span>
                  </div>
                </th>

                <th
                  onClick={() => handleSort("createdAt", "asc")}
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                >
                  <div className="flex justify-start">
                    <span>{t("JOB_APPLY_DATE")}</span>
                    <span>
                      {sort.sortBy === "createdAt" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortBy === "createdAt" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="rotate-180 w-4 h-4 " />
                        )}
                    </span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6 text-center">
                  {t("STATUS")}
                </th>
                <th scope="col" className="py-3 px-6 text-center  ">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {employeeList &&
                employeeList.map((item, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                    >
                      <th
                        scope="row"
                        className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white"
                      >
                        {i + 1 + 10 * (page - 1)}
                      </th>
                      {/* <td className="border-r py-4 px-6 text-gray-900">
                        {item?.Employee?.employeeId}
                      </td> */}
                      <td className="text-gray-900 py-4 px-6 border-r">
                        {item?.Employee?.name}
                      </td>
                      <td className="py-4 border-r px-6  text-gray-900">
                        {item?.Department?.name}
                      </td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        {item?.Job?.name}
                      </td>
                      <td className="border-r py-4 px-6 text-gray-900">
                        {item?.yearOfExperiece}
                      </td>
                      <td className="px-6 border-r py-4 text-gray-900">
                        {item?.Employee?.email}
                      </td>

                      <td className="py-4 text-left text-gray-900 px-6 border-r ">
                        {item?.createdAt
                          ? dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")
                          : "N/A"}{" "}
                      </td>
                      <td className="py-4 text-gray-900 px-6 border-r ">
                        {startCase(item.employmentStatus === "terminated" ? item.employmentStatus : item?.status)}
                      </td>

                      <td className="py-4 text-gray-900 px-6 border-l ">
                        <div className="">
                          <ul className="justify-center flex ">
                            <li
                              className="hover:bg-white px-2 hover:text-LightBlue py-2 "
                              onClick={() => handleView(item)}
                            >
                              <a title={t("O_VIEW")}>
                                {" "}
                                <AiFillEye className="w-5 h-5 cursor-pointer text-slate-600" />{" "}
                              </a>
                            </li>

                            <li
                              className="hover:bg-white px-2 hover:text-red-500 py-2 "
                              onClick={() => handleDelete(item)}
                            >
                              <a title={t("O_DELETE")}>
                                {" "}
                                <AiFillDelete className="w-5 h-5 cursor-pointer text-red-500" />{" "}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {isEmpty(employeeList) ? (
                <tr className="text-center dark:bg-gray-800 bg-white border-b dark:border-gray-700">
                  <td className="py-4 px-6 border-r" colSpan={10}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FinalEmployeeTable;